import React from "react";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
// import reportWebVitals from "./reportWebVitals";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import { ThemeProvider } from "@emotion/react";
import Theme from "./theme";
import store from "./state-management/store";
import AppMedia from "./theme/utils/AppMedia";

import "@arcgis/core/assets/esri/themes/light/main.css";
import "./theme/global-styles/index.scss";

const { MediaContextProvider } = AppMedia;
const render = () => {
  const App = require("./App").default;
  const gtmParams = { id: "GTM-5T2S9J" };

  ReactDOM.render(
    <React.StrictMode>
      <GTMProvider state={gtmParams}>
        <ThemeProvider theme={Theme.CE_THEME}>
          <MediaContextProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </MediaContextProvider>
        </ThemeProvider>
      </GTMProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

render();

if (process.env.NODE_ENV === "development") {
  if (process.env.REACT_APP_ENABLE_MOCK === "true") {
    const { worker } = require("./api/mock/browser");
    worker.start();
  }

  if (module.hot) {
    module.hot.accept("./App", render);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
